export default __webpack_public_path__ + "static/media/4.4ce182c9.png";